import classnames from "classnames"
import React, {Component} from "react"
import {Link} from "react-router-dom"

import {CustomIcon, Icon, LoadingIndicator} from "~/components/"

export default class Button extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(event) {
    if (this.props.onClick && !this.props.disabled) {
      this.props.onClick(event)
    }
  }

  renderButton() {
    let classes = classnames({
      "sh-button": true,
      "sh-button--primary": this.props.primary,
      "sh-button--error": this.props.error,
      "sh-button--secondary": this.props.secondary,
      "sh-button--disabled": this.props.disabled,
      "sh-button--loading": this.props.loading
    })
    let DynamicIcon = Icon
    if (this.props.icon && this.props.icon.startsWith("/")) {
      DynamicIcon = CustomIcon
    }
    return (
      <div
        disabled={this.props.disabled}
        className={classes}
        onClick={this.handleClick}
        style={this.props.style}
      >
        {this.props.icon && <DynamicIcon i={this.props.icon} />}
        {this.props.children || this.props.label}
        {this.props.loading && <LoadingIndicator message={false} />}
      </div>
    )
  }

  render() {
    if (this.props.to) {
      return <Link to={this.props.to}>{this.renderButton()}</Link>
    } else {
      return this.renderButton()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Button.js